import { ImportMapping, ImportMappingType } from "app/area/import-mappings/types-store";

export const setImportMapping = (index: number, newExternalValue: string, importMapping: ImportMapping[]): ImportMapping[] =>
  importMapping.map((value, i) => (i === index ? {
    importNumber: importMapping[index]?.importNumber,
    externalValue: newExternalValue,
    existingExternalValue: importMapping[index]?.existingExternalValue,
    type: (importMapping[index].type === ImportMappingType.New || importMapping[index].type === ImportMappingType.NewUpdated)
      ? ImportMappingType.NewUpdated
      : ImportMappingType.Updated
  } : value));

export const deleteImportMapping = (index: number, value: ImportMapping, importMapping: ImportMapping[]): ImportMapping[] => {
  importMapping?.splice(index, 1);
  return value.type === ImportMappingType.NewUpdated
    ? importMapping
    : importMapping.concat({
      importNumber: value.importNumber,
      externalValue: value.externalValue,
      type: ImportMappingType.Deleted
    });
};

export const importMappingCodeId = (codetableId: number, codeId: number) =>
  `code_${codetableId}_${codeId}`;
